import React, { Component } from 'react';
import axios from 'axios'
import * as FbUtils from '../../../../Utilities/FireBaseUtils'
import { Button, Divider, Form } from 'semantic-ui-react'
import * as moment from 'moment';
import { base, serverIp, getOrderKey, toCurrency, pythonApiIp } from '../../../../config/constants';
import * as UiConsts from '../../../../config/UiConstants.js'

export class WhatsappDepReqSendLost extends Component {
    constructor(props) {
        super(props);
        this.state = {
            order_num: '',
            totalOrderAmount: '',
            depositAmount: '',
            balance: '',
            phone: this.props.phone,
            loading: false,
            visible: true,
        }
    }

    cleanPhone = () => {
       // console.log("whatx1 clean phone:" + this.props.order.phone)
        let newPhone = "256" + this.props.order.phone.replace(/^0+/, '');
       // console.log("whatx12 clean phone:" + newPhone)
        return newPhone
    }

    sendToLost = () => {
        console.log("++++++ sendToDepRequested +++")
        console.log("cleanPhone:" + this.cleanPhone(this.props.order.phone))
        if (!this.props.order.phone) {
            alert("no phone number")
        } else if (!this.props.order) {
            alert("no order ")
        } else if (!this.props.order.order_num) {
            alert("no order number")
        }else {

            this.setState({ loading: true })

            var d = new Date();
            let now = moment().format('MMMM Do, h:mm:ss a');

            axios.post(pythonApiIp + 'sendToLost', {
                apiKey: "asdf@asdfasdf",
                order_num: this.props.order.order_num,
                phone: this.cleanPhone(this.props.order.phone),
                enteredBy: this.props.user.email,
            })
                .then((response) => {
                    this.setState({ loading: false })
                    console.log(response.data);


                })
                .catch((error) => {
                    console.log(error);
                    this.setState({ loading: false })
                });
        }
    }

    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }



    render() {




        return (
            this.state.loading ? <UiConsts.LoadingComponent /> : <div>
                <Divider horizontal>{'MAKE LOST SEND WHATSAPP'}</Divider>
                <Form onSubmit={this.sendToLost}>
                    <Button color='red'> SEND REMINDER SEND TO LOST</Button>
                </Form>
            </div>
        )
    }
}

export default WhatsappDepReqSendLost;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Whatsapp/WhatsappDepReqSendLost.js